import { createContext } from "react";
import { Scaffold } from "./scaffold";

export const ScaffoldContext = createContext<Scaffold | undefined>(undefined);
